import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgKey = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M15.5 15.5 6.477 6.477M13.5 13.5l2-2m-4 0 3-3"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={4} cy={4} r={3.5} stroke="currentColor" />
  </svg>
);
const ForwardRef = forwardRef(SvgKey);
export default ForwardRef;
